module.exports = __webpack_public_path__ + "img/穿山甲.8a7fe375.jpg";